import script from "./MiscNotesDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./MiscNotesDialog.vue?vue&type=script&lang=ts&setup=true"

import "./MiscNotesDialog.vue?vue&type=style&index=0&id=33b211a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b211a0"]])

export default __exports__